import { Columns } from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';
import {
  collapsiblePatientTableHeaderStyles,
  MemberClaims,
} from './riskPatientDetailsHelper';
import {
  dropDownMenuItemsAlphabets,
  dropDownMenuItemsValues,
} from './tableSortHelper';

export interface CostTrendDataFormat {
  value: number | string;
}
export interface WasteCalculatorSubCategoriesDetails {
  procedures: string;
  topProcedures: string[];
  totalCost: number;
  avgCost: number;
  members: number;
  claims: number;
  member_unique_id: string;
  claimData: MemberClaims[];
}

export const wastageSubCategoriesTableColumns: Columns[] = [
  {
    name: 'Procedures',
    align: 'left',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '172px',
    cellPadding: '8px 18px 8px 48px',
  },
  {
    name: 'Top Providers',
    align: 'left',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '137px',
  },
  {
    name: 'Total Cost',
    align: 'left',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '208px',
  },
  {
    name: 'Avg Cost',
    align: 'left',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '238px',
  },
  {
    name: 'Memnbers',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '60px',
  },
  {
    name: 'Claims',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '200px',
    cellPadding: '8px 28px 8px 20px',
  },
];

export const getMonth = (month: number, year: number) => {
  switch (month) {
    case 1:
      return 'Jan-' + year;
    case 2:
      return 'Feb-' + year;
    case 3:
      return 'Mar-' + year;
    case 4:
      return 'Apr-' + year;
    case 5:
      return 'May-' + year;
    case 6:
      return 'Jun-' + year;
    case 7:
      return 'Jul-' + year;
    case 8:
      return 'Aug-' + year;
    case 9:
      return 'Sep-' + year;
    case 10:
      return 'Oct-' + year;
    case 11:
      return 'Nov-' + year;
    case 12:
      return 'Dec-' + year;
    default:
      return 'Invalid';
  }
};

export const subCatergoriesTableColumns: Columns[] = [
  {
    name: 'Procedures',
    sortColumnName: 'wastageSubCategory',
    align: 'left',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '380px',
    cellPadding: '8px 36px 8px 56px',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'Total Cost',
    sortColumnName: 'totalCost',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '250px',
    cellPadding: '8px 16px 8px 20px',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Avg Cost',
    sortColumnName: 'averageCost',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '250px',
    cellPadding: '8px 16px 8px 20px',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Members',
    sortColumnName: 'totalMembers',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '200px',
    cellPadding: '8px 56px 8px 20px',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Claims',
    sortColumnName: 'totalClaims',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '200px',
    cellPadding: '8px 56px 8px 20px',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
];

export const topProvidersTableColumns: Columns[] = [
  {
    name: 'Providers',
    sortColumnName: 'providerName',
    align: 'left',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '380px',
    cellPadding: '8px 36px 8px 56px',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'Total Cost',
    sortColumnName: 'totalCost',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '250px',
    cellPadding: '8px 16px 8px 20px',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Avg Cost',
    sortColumnName: 'averageCost',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '250px',
    cellPadding: '8px 16px 8px 20px',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Members',
    sortColumnName: 'totalMembers',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '200px',
    cellPadding: '8px 56px 8px 20px',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Claims',
    sortColumnName: 'totalClaims',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '200px',
    cellPadding: '8px 56px 8px 20px',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
];

export const subCategoriesColumns = [
  'Member ID',
  'Total Cost',
  'Claims',
  'Enrollment Status',
  'Costliest Drugs',
  'Gender',
  'Age',
  'First Name',
  'Last Name',
  'Member Relationship',
  'DOB',
];

export const subCategoriesDefaultColumns = [
  'Member ID',
  'Total Cost',
  'Claims',
  'Enrollment Status',
];
